<style lang="scss"></style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 10px;">
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
        {{ $t("gongchangzhibiao") }}
      </p>
      <div style="margin-left: 18px;">
        <p style="font-size: 12px;line-height: 22px;color: #C0C4CC;">
          {{ $t("tongjishijian") + " " + dayjs(efficiency.currentShift.begin).format("MM-DD HH:mm") + "~" + dayjs(efficiency.currentShift.end).format("MM-DD HH:mm") }}
        </p>
      </div>
      <div v-if="efficiency.oee != null" style="margin-left: 18px;">
        <p style="font-size: 18px;line-height: 22px;color: #419FFF;">
          {{ $t("OEE") + ":" + (efficiency.oee * 100).toFixed(1) + "%" }}
        </p>
      </div>


    </div>
    <div style="display: flex;justify-content:space-around;align-items: center;" :style="{ height: contentHeight + 'px' }">
      <div style="flex: 1;flex-shrink: 0;">
        <div id="kaijilvChart" :style="{ height: contentHeight + 'px' }" style="width: 100%;"></div>
      </div>
      <div style="flex: 1;flex-shrink: 0;">
        <div id="jiadonglvChart" :style="{ height: contentHeight + 'px' }" style="width: 100%;"></div>
      </div>
      <div style="flex: 1;flex-shrink: 0;">
        <div id="liangpinlvChart" :style="{ height: contentHeight + 'px' }" style="width: 100%;"></div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_monitor_workshop_mes_oee",
  components: {},

  data() {
    return {
      timmer: null,
      contentHeight: 0,
      efficiency: {
        upEfficency: 0,
        timeEfficency: 0,
        currentShift: {
          begin: 0,
          end: 0,
        },
      },
      kjlChart: null,
      jdlChart: null,
      lplChart: null,
    };
  },
  watch: {
    "$attrs.orgId"(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getEfficiencyStatistics();
    },
  },
  created() {
    this.timmer = setInterval(() => {
      this.getEfficiencyStatistics();
    }, 120000);
    setTimeout(() => {
      //等待获取高度再生成,resize是延迟800的，这里1000
      this.getEfficiencyStatistics();
    }, 1000);
    this.utils.event_hub.$on("WORKSHOP_MES_OEE", () => {
      this.getEfficiencyStatistics();
    });
  },
  activated() {
    this.resize();
  },
  mounted() {
    setTimeout(() => {
      if (!this.kjlChart) {
        this.initKjlChart();
      }
      if (!this.jdlChart) {
        this.initJdlChart();
      }
      if (!this.lplChart) {
        this.initLplChart();
      }
      this.resize();
    }, 700);

    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {
    clearInterval(this.timmer);
    this.utils.event_hub.$off("WORKSHOP_MES_OEE");
  },
  methods: {
    async getEfficiencyStatistics() {
      // 增加：看板设置里的稼动率计算参数
      let monitorSetting = localStorage.getItem('MONITOR_SETTING');
      if (!monitorSetting) {
        monitorSetting = {};
      } else {
        monitorSetting = JSON.parse(monitorSetting);
      }
      
      const operationRateCalculateType = monitorSetting.MONITOR_WORKSHOP_FACTORY_INDICATOR_OPERATE_RATE_CALCULATION_TYPE || 1;
      let response = await this.http.get("/web/equipment/getMesEfficiencyStatistics", {
        params: {
          orgId: this.$attrs.orgId,
          operationRateCalculateType: operationRateCalculateType
        },
      });
      this.efficiency = response.data;

      if (this.efficiency.upEfficency != null) {
        this.kjlChart.setOption({
          series: [
            {
              data: [
                {
                  value: this.efficiency.upEfficency * 100,
                  name: this.$t("kaijilv"),
                },
              ],
            },
          ],
        });
      }

      if (this.efficiency.timeEfficency != null) {
        this.jdlChart.setOption({
          series: [
            {
              data: [
                {
                  value: this.efficiency.timeEfficency * 100,
                  name: this.$t("jiadonglv"),
                },
              ],
            },
          ],
        });
      }
      if (this.efficiency.goodRate != null) {
        this.lplChart.setOption({
          series: [
            {
              data: [
                {
                  value: this.efficiency.goodRate * 100,
                  name: this.$t("liangpinlv"),
                },
              ],
            },
          ],
        });
      }

      this.resize();
    },
    resize() {
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;

        setTimeout(() => {
          if (this.kjlChart) {
            this.kjlChart.resize();
          }
          if (this.jdlChart) {
            this.jdlChart.resize();
          }
          if (this.lplChart) {
            this.lplChart.resize();
          }
        }, 0);
      }, 800); //子组件填800，因为父组件500，等父组件调整好高度先
    },
    initKjlChart() {
      let option = {
        backgroundColor: null,
        series: [
          {
            type: "gauge",
            center: ["50%", "75%"],
            startAngle: 190,
            endAngle: -10,
            min: 0,
            max: 100,
            radius: "110%",
            splitNumber: 18,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#6FE5FF", // 25% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#1C70C6", // 0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            progress: {
              show: true,
              width: 12,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                width: 12,
                color: [[1, "#858A93"]],
              },
            },
            axisTick: {
              distance: -22,
              splitNumber: 3,
              lineStyle: {
                width: 1,
                color: "#858A93",
              },
            },
            splitLine: {
              show: false,
              distance: -12,
              length: 12,
              lineStyle: {
                width: 1,
                color: "#858A93",
              },
            },
            axisLabel: {
              distance: 0,
              color: "#858A93",
              fontSize: 30,
              show: false,
            },
            anchor: {
              show: false,
            },

            title: {
              offsetCenter: [0, "-4%"],
              fontSize: 14,
              color: "#ffffff",
            },
            detail: {
              valueAnimation: true,
              width: "60%",
              lineHeight: 26,
              borderRadius: 8,
              offsetCenter: [0, "-34%"],
              fontSize: 20,
              fontWeight: "bolder",
              formatter: (value) => {
                return value.toFixed(1) + "%";
              },
              color: "#ffffff",
            },
            data: [
              {
                value: 0,
                name: this.$t("kaijilv"),
              },
            ],
          },
        ],
      };

      var chartDom = document.getElementById("kaijilvChart");
      this.kjlChart = this.echarts.init(chartDom);
      option && this.kjlChart.setOption(option);
    },
    initJdlChart() {
      let option = {
        backgroundColor: null,
        series: [
          {
            type: "gauge",
            center: ["50%", "75%"],
            startAngle: 190,
            endAngle: -10,
            min: 0,
            max: 100,
            radius: "110%",
            splitNumber: 18,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#6FE5FF", // 25% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#1C70C6", // 0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            progress: {
              show: true,
              width: 12,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                width: 12,
                color: [[1, "#858A93"]],
              },
            },
            axisTick: {
              distance: -22,
              splitNumber: 3,
              lineStyle: {
                width: 1,
                color: "#858A93",
              },
            },
            splitLine: {
              show: false,
              distance: -12,
              length: 12,
              lineStyle: {
                width: 1,
                color: "#858A93",
              },
            },
            axisLabel: {
              distance: 0,
              color: "#858A93",
              fontSize: 30,
              show: false,
            },
            anchor: {
              show: false,
            },

            title: {
              offsetCenter: [0, "-4%"],
              fontSize: 14,
              color: "#ffffff",
            },
            detail: {
              valueAnimation: true,
              width: "60%",
              lineHeight: 26,
              borderRadius: 8,
              offsetCenter: [0, "-34%"],
              fontSize: 20,
              fontWeight: "bolder",
              formatter: (value) => {
                return value.toFixed(1) + "%";
              },
              color: "#ffffff",
            },
            data: [
              {
                value: 0,
                name: this.$t("jiadonglv"),
              },
            ],
          },
        ],
      };

      var chartDom = document.getElementById("jiadonglvChart");
      this.jdlChart = this.echarts.init(chartDom);
      option && this.jdlChart.setOption(option);
    },
    initLplChart() {
      let option = {
        backgroundColor: null,
        series: [
          {
            type: "gauge",
            center: ["50%", "75%"],
            startAngle: 190,
            endAngle: -10,
            min: 0,
            max: 100,
            radius: "110%",
            splitNumber: 18,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#6FE5FF", // 25% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#1C70C6", // 0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            progress: {
              show: true,
              width: 12,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                width: 12,
                color: [[1, "#858A93"]],
              },
            },
            axisTick: {
              distance: -22,
              splitNumber: 3,
              lineStyle: {
                width: 1,
                color: "#858A93",
              },
            },
            splitLine: {
              show: false,
              distance: -12,
              length: 12,
              lineStyle: {
                width: 1,
                color: "#858A93",
              },
            },
            axisLabel: {
              distance: 0,
              color: "#858A93",
              fontSize: 30,
              show: false,
            },
            anchor: {
              show: false,
            },

            title: {
              offsetCenter: [0, "-4%"],
              fontSize: 14,
              color: "#ffffff",
            },
            detail: {
              valueAnimation: true,
              width: "60%",
              lineHeight: 26,
              borderRadius: 8,
              offsetCenter: [0, "-34%"],
              fontSize: 20,
              fontWeight: "bolder",
              formatter: (value) => {
                return value.toFixed(1) + "%";
              },
              color: "#ffffff",
            },
            data: [
              {
                value: 0,
                name: this.$t("liangpinlv"),
              },
            ],
          },
        ],
      };

      var chartDom = document.getElementById("liangpinlvChart");
      this.lplChart = this.echarts.init(chartDom);
      option && this.lplChart.setOption(option);
    },
  },
};
</script>
